export default [
  // {
  //   id: 1,
  //   name: 'Akhilesh Enterprises',
  //   description:
  //     'We specialist in all kind of wood furniture polishing spray duco,lamination work and Painting work.',
  //   img: require('../assets/ProjectImg/AkhileshEnterprises.jpg'),
  //   type: 'Html',
  //   gitUrl: 'https://github.com/avtarprajapati/AkhileshEnterprises',
  //   liveUrl: 'https://akhileshenterprises.com/',
  // },
  {
    id: 2,
    name: 'Movies Shows Ultimate',
    description:
      'Million of movies and tv to explore that through this moviesshowsultimate website.',
    img: require('../assets/ProjectImg/MoviesShows.jpg'),
    type: 'React',
    gitUrl: 'https://github.com/avtarprajapati/moviesshowsultimate',
    liveUrl: 'https://moviesshowsultimate.netlify.app/',
  },
  {
    id: 5,
    name: 'Weather Forecast',
    description: '5 days weather forecast of your favorite city.',
    img: require('../assets/ProjectImg/WeatherForecast.jpg'),
    type: 'React',
    gitUrl: 'https://github.com/avtarprajapati/weather-forecast',
    liveUrl: 'https://weatherforecastdays.netlify.app/',
  },
  {
    id: 7,
    name: 'Ecommerce With Augmented Reality',
    description:
      'This project is to feel products that are suitable or not so that user can buy it.',
    img: require('../assets/ProjectImg/EcommerceWithAR.PNG'),
    type: 'full-stack',
    gitUrl: 'https://github.com/avtarprajapati/EcommerceWithAR-Frontend',
    liveUrl: 'https://ecommerce-with-ar.vercel.app/',
  },
  {
    id: 3,
    name: 'Youtube Clone',
    description: 'Create Youtube Clone through the provided API by them.',
    img: require('../assets/ProjectImg/YoutubeClone.jpg'),
    type: 'React',
    gitUrl: 'https://github.com/avtarprajapati/youtubeclone',
    liveUrl: 'https://avtarprajapati.github.io/youtubeclone/',
  },
  {
    id: 4,
    name: 'Natours Tours',
    description: 'Tourism website Natours created using html,css,js,scss.',
    img: require('../assets/ProjectImg/Natours.jpg'),
    type: 'Html',
    gitUrl: 'https://github.com/avtarprajapati/Natours-tours',
    liveUrl: 'https://natours-tours.netlify.app/',
  },

  {
    id: 6,
    name: 'Unsplash Photos',
    description: 'Search photo by giving to name.',
    img: require('../assets/ProjectImg/Unsplash.jpg'),
    type: 'React',
    gitUrl: 'https://github.com/avtarprajapati/Unsplash-Photos',
    liveUrl: 'https://unsplash-photos.netlify.app/',
  },
];
